import React from "react";
import { Spinner } from "react-bootstrap";

// Small inline spinner shown inside a button while its action runs.
const ButtonSpinner: React.FC = () => (
  <Spinner
    as="span"
    animation="border"
    size="sm"
    role="status"
    aria-hidden="true"
    className="mr-2"
  />
);

export default ButtonSpinner;
